import { createSlice } from "@reduxjs/toolkit";
import { resetPatientData } from "../../../system/store/reset.slice";

const initialState = {
  data: null,
};

export const medicationsSlice = createSlice({
  name: "entities/patient-stats/medications-slice",
  initialState,
  reducers: {
    setMedications: (state, action) => {
      state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetPatientData, () => initialState);
  },
});

export const { setMedications } = medicationsSlice.actions;

export default medicationsSlice.reducer;
